/**
 * Shared document-first layout tokens for agreement view / sign modals.
 * PDF region grows to fill available height; metadata and signature sit in a compact footer strip.
 */

export function agreementModalPaperSx(isMobile, theme) {
  return {
    borderRadius: isMobile ? 0 : theme.shape.borderRadius,
    maxHeight: isMobile ? '100%' : '92vh',
    height: isMobile ? '100dvh' : '92vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  };
}

export const agreementModalTitleSx = {
  flexShrink: 0,
  py: 1.5,
  px: { xs: 1.5, sm: 2 },
  borderBottom: 1,
  borderColor: 'divider',
};

export const agreementModalContentSx = {
  flex: 1,
  minHeight: 0,
  p: 0,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

/** Primary PDF column — takes all space above footer strip. */
export const agreementPdfRegionSx = {
  flex: 1,
  minHeight: { xs: 'min(48vh, 360px)', sm: 0 },
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  px: { xs: 1.5, sm: 2 },
  pt: 1,
  pb: { xs: 0.5, sm: 1 },
};

/** Compact strip under PDF: metadata, signature fields, or actions. */
export const agreementModalFooterStripSx = {
  flexShrink: 0,
  px: { xs: 1.5, sm: 2 },
  py: { xs: 1, sm: 1.25 },
  borderTop: 1,
  borderColor: 'divider',
  bgcolor: 'background.paper',
};

export const agreementModalActionsSx = {
  flexShrink: 0,
  px: { xs: 1.5, sm: 2 },
  py: 1,
  borderTop: 1,
  borderColor: 'divider',
  gap: 1,
};
